import { render, staticRenderFns } from "./TabelaTipoCreditoAssunto.vue?vue&type=template&id=4cf145aa&scoped=true&"
import script from "./TabelaTipoCreditoAssunto.vue?vue&type=script&lang=js&"
export * from "./TabelaTipoCreditoAssunto.vue?vue&type=script&lang=js&"
import style0 from "./TabelaTipoCreditoAssunto.vue?vue&type=style&index=0&id=4cf145aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf145aa",
  null
  
)

export default component.exports